const routes = [{
  path: '/',
  name: '首页',
  component: () => import('@/pages/home/home.vue')
}]
export default routes